/*
 * @Author: edvardchen
 * @Date:   2016-12-26 19:54:16
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-02-17 15:27:47
 */

import React from 'react';

const attachCustomAttributes = (node) => {
  if (node) {
    node.setAttribute('webkit-playsinline', '');
    node.setAttribute('playsinline', '');
    node.setAttribute('x-webkit-airplay', '');
    node.setAttribute('qb-video-float-mode', false);
  }
};

const Video = (props) => <video ref={attachCustomAttributes} preload="metadata" {...props} />;

export default Video;
